<!-- CONCLAVE LIST VIEW COMPONENT -->

<div class="min-h-screen bg-white p-4 md:p-6">
  <div class="mx-auto max-w-7xl">

    <!-- Header -->
    <div class="mb-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">

      <!-- Left -->
      <div>
        <h1 class="text-3xl font-semibold text-[#073B4C]">Conclave</h1>

        <!-- Tabs -->
        <div class="mt-4 flex items-center gap-8 border-b border-slate-200">
          <button
            type="button"
            (click)="onTabChange('past')"
            class="relative pb-3 text-sm font-medium"
            [ngClass]="{
              'text-[#073B4C]': activeTab === 'past',
              'text-slate-400 hover:text-slate-700': activeTab !== 'past'
            }">
            Past
            <span
              class="absolute bottom-0 left-0 h-[2px] w-full"
              [ngClass]="{ 'bg-[#073B4C]': activeTab === 'past', 'bg-transparent': activeTab !== 'past' }"></span>
          </button>

          <button
            type="button"
            (click)="onTabChange('upcoming')"
            class="pb-3 text-sm font-medium"
            [ngClass]="{
              'text-[#073B4C]': activeTab === 'upcoming',
              'text-slate-400 hover:text-slate-700': activeTab !== 'upcoming'
            }">
            Upcoming
          </button>
        </div>

      </div>

      <!-- Right -->
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center">

        <!-- Add Button -->
        <button
          routerLink="/conclave/create" 
          *ngIf="create_conclave"
          class="flex h-11 items-center justify-center gap-2 rounded-xl bg-[#1E88E5] px-5 text-sm font-medium text-white shadow-sm transition hover:bg-blue-700">
          <span class="text-lg">+</span>
          Schedule New Conclave
        </button>

        <!-- Filter -->
        <select
  [(ngModel)]="year"
  (change)="onYearChange()"
  class="h-11 rounded-lg border border-slate-300 bg-white px-4 text-sm text-slate-700 outline-none focus:border-[#073B4C]">


  @for (y of years; track y) {
    <option [value]="y">
      {{ y }}
    </option>
  }

</select>

      </div>
    </div>

    <!-- List Cards -->
   <div class="space-y-5" *ngIf="conclave_page">


  @if (isLoading) {
    <div class="text-center py-10">
      Loading conclaves...
    </div>
  }

  @if (errorMessage) {
    <div class="text-center text-red-500 py-10">
      {{ errorMessage }}
    </div>
  }

  @for (conclave of filteredConclaves; track conclave.id) {


    <div
      *ngIf ="conclave_list"
      class="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-md cursor-pointer"
      [routerLink]="['/conclave/view', conclave.id]">

      <div class="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">

        <!-- Left -->
        <div class="flex items-start gap-5">

          <!-- Date -->
          <div class="overflow-hidden rounded-lg border border-slate-300">

            <div
              class="px-4 py-1 text-center text-xs font-medium text-white"
              [ngClass]="{
                'bg-[#9EB0B7]': activeTab === 'past',
                'bg-[#1E88E5]': activeTab === 'upcoming'
              }">
             {{ getMonthName(conclave.start_date) }}
            </div>

            <div
              class="flex h-[72px] w-[72px] items-center justify-center bg-white text-5xl font-semibold"
              [ngClass]="{
                'text-[#9EB0B7]': activeTab === 'past',
                'text-black': activeTab === 'upcoming'
              }">
              {{ getDay(conclave.start_date) }}
            </div>

          </div>

          <!-- Content -->
          <div>

            <div class="flex flex-wrap items-center gap-3">

              <h2 class="text-xl font-semibold text-[#073B4C]">
                {{ conclave.title }}
              </h2>

              <span
                class="rounded-full px-3 py-1 text-xs font-medium text-white"
                [ngClass]="{
                  'bg-lime-500': conclave.ticket_type?.toLowerCase() === 'free',
                  'bg-[#073B4C]': conclave.ticket_type?.toLowerCase() !== 'free'
                }">

                {{ conclave.ticket_type || 'Free' }}

              </span>

            </div>

            <p class="mt-1 text-sm text-slate-600">
              Organised by : Teacher Factory
            </p>

            <p class="mt-2 text-md text-slate-700">
              Venue :
              {{ conclave.venue }}
              @if (conclave.city) {
                , {{ conclave.city }}
              }
            </p>

          </div>

        </div>

        <!-- Right -->
        <div class="text-right">

          <h3 class="text-4xl font-semibold text-[#073B4C]">
            {{ conclave.selected_groups?.length || 0 }}
          </h3>

          <p class="mt-1 text-sm text-slate-600">
            No. of Registrations
          </p>

        </div>

      </div>

    </div>

  }

  @if (!isLoading && filteredConclaves.length === 0) {

    <div class="text-center py-10 text-slate-500">
      No conclaves found
    </div>
  }

</div>


</div>
</div>


